// @ts-nocheck

import { useEffect, useMemo, useState } from 'react';
import v4 from 'uuid/v4';

import Client from '../client';
import config from '../config/app.config';
import { getWapiDynamicEndpoint } from '../config/urls';
import { getLang } from '../i18n/l10n';
import { VideoPlayerTypes, VideoPlayerType } from '../types/videoPlayer';
import { getCustomHeaders } from '../utils';

const { webHost } = config;

type streamConfigProps = {
  streamData: string;
  matchId?: number;
  jwt: string;
  type?: VideoPlayerType;
};

const useStreamConfig = ({ streamData, matchId, jwt, type = VideoPlayerTypes.STREAM }: streamConfigProps) => {
  const [ip, setIp] = useState(null);

  const url = useMemo(() => {
    if (type === VideoPlayerTypes.STREAM) {
      return `${webHost[getLang()]}/betting/api/stream.php`;
    }
    if (type === VideoPlayerTypes.HIGHLIGHT) {
      return `${getWapiDynamicEndpoint()}/betting/streams`;
    }

    return null;
  }, [type]);

  const body = useMemo(() => {
    if (type === VideoPlayerTypes.STREAM) {
      const data = { stream: streamData, match_id: matchId };
      return `params=${encodeURIComponent(JSON.stringify(data))}`;
    }
    if (type === VideoPlayerTypes.HIGHLIGHT) {
      const data = { streamData, jwt };
      return JSON.stringify({
        id: v4(),
        ns: 'betting/streams',
        method: 'GetHighlightStreamUrls',
        params: data,
      });
    }

    return null;
  }, [jwt, matchId, streamData, type]);

  useEffect(() => {
    let didCancel = false;
    const fetchData = async () => {
      try {
        const response = await fetch('https://wapi-ipv6.winamax.fr/core/tools/http-helper/ip');
        const json = await response.json();

        if (!didCancel) {
          setIp(json.data.ip);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();

    return () => {
      didCancel = true;
    };
  }, []);

  if (!ip) {
    return {
      url,
      config: null,
    };
  }

  const config = {
    method: 'POST',
    credentials: 'same-origin',
    body,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'x-wam-user-ip': ip,
      ...getCustomHeaders({ jwt, tracker: Client.tracker }),
    },
  };

  return {
    url,
    config: JSON.stringify(config),
  };
};

export default useStreamConfig;
